"use strict";
/// <reference path="./CategoryChooser.d.ts" />
Object.defineProperty(exports, "__esModule", { value: true });
exports.ChooserUsedInAcquisition = exports.ChooserUsedInSimpleSearch = exports.ChooserUsedInNew = exports.ChooserUsedInSearch = exports.ContentAllowedMode = exports.ChooserMode = void 0;
require("@progress/kendo-ui");
const Cookies = require("js-cookie");
const Utilities_1 = require("../../javascript/Utilities");
var ChooserMode;
(function (ChooserMode) {
    ChooserMode[ChooserMode["DropDown"] = 0] = "DropDown";
    ChooserMode[ChooserMode["Groups"] = 1] = "Groups";
})(ChooserMode = exports.ChooserMode || (exports.ChooserMode = {}));
/**
 * The content semantics this category enforces
 */
var ContentAllowedMode;
(function (ContentAllowedMode) {
    /**
     * Documents of that category must not have a content at all
     */
    ContentAllowedMode[ContentAllowedMode["No"] = 0] = "No";
    /**
     * Documents of that category may have a content, but it may be only manipulated by the
     * system, not by means of user interaction.
     */
    ContentAllowedMode[ContentAllowedMode["SystemOnly"] = 1] = "SystemOnly";
    /**
     * Documents of that category may have a content, with no limitations (default)
     */
    ContentAllowedMode[ContentAllowedMode["Yes"] = 2] = "Yes";
})(ContentAllowedMode = exports.ContentAllowedMode || (exports.ContentAllowedMode = {}));
exports.ChooserUsedInSearch = 1;
exports.ChooserUsedInNew = 2;
exports.ChooserUsedInSimpleSearch = 3;
exports.ChooserUsedInAcquisition = 4;
var CategoriesOrder;
(function (CategoriesOrder) {
    CategoriesOrder[CategoriesOrder["SortedAlphabetically"] = 0] = "SortedAlphabetically";
    CategoriesOrder[CategoriesOrder["InGroupOrder"] = 1] = "InGroupOrder";
})(CategoriesOrder || (CategoriesOrder = {}));
class CategoryChooserImpl {
    static init($elem, options) {
        return $elem.each(function () {
            let $this = $(this);
            let synData = CategoryChooserImpl.getData($this);
            if (!synData) {
                synData = $.extend({}, CategoryChooserImpl.DefaultOptions, options);
                CategoryChooserImpl.setData($this, synData);
                if (synData.multiSelect) {
                    synData.showDependsCheckbox = false;
                    synData.showTreeButton = false;
                }
                $this.trigger("beginInit");
                $this.addClass("synCategoryChooser");
                // true to prevent raising events when internally a manual selection change is performed.
                CategoryChooserImpl.setState_InternalChange($this, false);
                require.ensure(["./CategoryChooser.tmpl.less"], function (require) {
                    require("./CategoryChooser.tmpl.less");
                    let markup = require("./CategoryChooser.tmpl.html");
                    let guid = Utilities_1.synUtil.getGUID();
                    let idData = {
                        categChooserLabelId: "categChooserLabel_" + guid,
                        categChooserControlId: "categChooserControl_" + guid,
                        treeButtonId: "treeButton_" + guid,
                        dependsLabelId: "dependsLabel_" + guid,
                        dependsCheckboxId: "dependsCheckbox_" + guid,
                        showTreeButton: synData.showTreeButton,
                        showDependsCheckbox: synData.showDependsCheckbox,
                        synUtil: Utilities_1.synUtil
                    };
                    let template = kendo.template(markup);
                    $this.html("").append($(template(idData)));
                    $("#" + idData.dependsCheckboxId)
                        .off("change").on("change", function () {
                        let checked = $(this).prop("checked");
                        $(this).data("lastVal", checked);
                        $this.trigger("dependsChangedManually", [checked]);
                    });
                    CategoryChooserImpl.setState_Depends($this, false);
                    if (synData.showDependsCheckbox) {
                        $("#" + idData.dependsCheckboxId).on("click", function () {
                            if ($(this).prop("checked"))
                                CategoryChooserImpl.setState_Depends($this, true);
                            else
                                CategoryChooserImpl.setState_Depends($this, false);
                        });
                    }
                    if (synData.showTreeButton)
                        CategoryChooserImpl.initTreeButton($this);
                    CategoryChooserImpl.setState_Depends($this, false);
                    if (synData.showDependsCheckbox)
                        CategoryChooserImpl.initDependsCheckbox($this);
                    CategoryChooserImpl.initChooserControl($this, $this.children(".chooserControl"), synData);
                });
            }
        });
    }
    static destroy($elem) {
        return $elem.each(function () {
            let $this = $(this);
            let mode = CategoryChooserImpl.getState_ChooserMode($this);
            let $control = CategoryChooserImpl.getChooserControl($this);
            CategoryChooserImpl.destroyTooltip($elem);
            if (mode === ChooserMode.DropDown) {
                let dropDown = CategoryChooserImpl.getDropDownList($this);
                if (dropDown)
                    dropDown.destroy();
            }
            else {
                let menu = $control.children("ul").data("kendoMenu");
                if (menu)
                    menu.destroy();
                $control.removeData("selectedCategory");
            }
            CategoryChooserImpl.removeData($this);
            CategoryChooserImpl.removeState_CategoryGroupMenu($this);
            CategoryChooserImpl.removeState_CategoryGroupInfo($this);
            CategoryChooserImpl.removeState_ChooserMode($this);
            CategoryChooserImpl.removeState_Depends($this);
            CategoryChooserImpl.removeState_InternalChange($this);
            CategoryChooserImpl.removeState_LastSelectedIdx($this);
            $this.removeClass("synCategoryChooser msie edge");
            $this.children().remove();
            $this.off("beginInit categoriesReceived initSuccess initFailed endInit beforeCategorySelected categorySelected categorySelectedManually categoriesSelected categoriesSelectedManually dependsChangedManually");
        });
    }
    static enable($elem, enable) {
        return $elem.each(function () {
            let $this = $(this);
            let mode = CategoryChooserImpl.getState_ChooserMode($this);
            if (mode === ChooserMode.DropDown)
                CategoryChooserImpl.getDropDownList($elem).enable(enable);
            else
                CategoryChooserImpl.getState_CategoryGroupMenu($this).enable(CategoryChooserImpl.getChooserControl($this).find("li:first"), enable);
            Utilities_1.synUtil.toggleEnabledState($elem.children(".ccTreeButton"), enable);
            Utilities_1.synUtil.toggleEnabledState($elem.children(".ccDependsCheckbox"), enable);
            $elem.children(".ccLabel").toggleClass("k-state-disabled", !enable);
        });
    }
    static setSelectedCategory($elem, catId, depends, triggerEvenIfSameCategory) {
        return $elem.each(function () {
            let $this = $(this);
            let mode = CategoryChooserImpl.getState_ChooserMode($this);
            if (mode === ChooserMode.DropDown)
                CategoryChooserImpl.setSelectedCategory_DropDown($this, catId, depends, triggerEvenIfSameCategory);
            else
                CategoryChooserImpl.setSelectedCategory_GroupControl($this, catId, depends, triggerEvenIfSameCategory);
            if (depends)
                CategoryChooserImpl.setDepends($this, depends);
        });
    }
    static setSelectedCategories($elem, catIds) {
        return $elem.each(function () {
            let $this = $(this);
            let synData = CategoryChooserImpl.getData($this);
            if (synData.multiSelect) {
                let mode = CategoryChooserImpl.getState_ChooserMode($this);
                let catObj = {};
                let changed = false;
                for (let catId of catIds)
                    catObj[catId] = true;
                if (mode === ChooserMode.DropDown) {
                    let dropDown = CategoryChooserImpl.getDropDownList($elem);
                    dropDown.ul.find("input.multiSelectCheckBox").each((idx, curElem) => {
                        let $curElem = $(curElem);
                        let oldChecked = $curElem.prop("checked");
                        let idString = $curElem.siblings("span.name").attr("data-id");
                        let catId = idString ? parseInt(idString, 10) : undefined;
                        let newChecked = catId ? (catObj[catId] || false) : false;
                        $curElem.prop("checked", newChecked);
                        if (newChecked !== oldChecked)
                            changed = true;
                    });
                }
                else
                    // not implemented!
                    throw new Error(("NotImplementedException"));
                if (changed) {
                    $this.trigger("categoriesSelected", [CategoryChooserImpl.getSelectedCategories($this)]);
                    let $control = CategoryChooserImpl.getChooserControl($elem);
                    if (mode === ChooserMode.DropDown)
                        CategoryChooserImpl.updateDropdownHeader($this);
                    else
                        CategoryChooserImpl.updateGroupControlHeader($this, $control);
                }
            }
        });
    }
    static setDepends($elem, depends) {
        return $elem.each(function () {
            let $this = $(this);
            let synData = CategoryChooserImpl.getData($this);
            let state_depends = CategoryChooserImpl.getState_Depends($this);
            if (synData.showDependsCheckbox && (state_depends !== depends)) {
                let curCateg = CategoryChooserImpl.getSelectedCategory($this);
                if (curCateg)
                    CategoryChooserImpl.setState_Depends($this, curCateg.isAbstract || depends);
                $this.find(".ccDependsCheckbox").prop("checked", CategoryChooserImpl.getState_Depends($this));
            }
        });
    }
    static getSelectedCategory($elem) {
        let selectedCategories = CategoryChooserImpl.getSelectedCategories($elem);
        let cat = (selectedCategories && selectedCategories.length) ? $.extend({}, selectedCategories[0]) : undefined;
        if (cat)
            cat.depends = cat.isAbstract || CategoryChooserImpl.getState_Depends($elem);
        return cat;
    }
    static getSelectedCategories($elem) {
        let synData = CategoryChooserImpl.getData($elem);
        let mode = CategoryChooserImpl.getState_ChooserMode($elem);
        let $control = CategoryChooserImpl.getChooserControl($elem);
        if (synData.multiSelect) {
            let selectedCategories = [];
            if (mode === ChooserMode.Groups) {
                $control.find("span.categoryListItem").each((idx, curElem) => {
                    let $multiSelectCheckBox = $(curElem).find("input.multiSelectCheckBox");
                    if ($multiSelectCheckBox.prop("checked")) {
                        let $listItem = $(curElem).closest("li.k-item");
                        let cat = CategoryChooserImpl.getCategory($elem, parseInt($listItem.attr("data-id"), 10));
                        if (cat)
                            selectedCategories.push(cat);
                    }
                });
            }
            else {
                let dropDown = CategoryChooserImpl.getDropDownList($elem);
                if (dropDown) {
                    dropDown.ul.find("input.multiSelectCheckBox:checked").each(function (idx, curElem) {
                        let $nameSpan = $(curElem).siblings("span.name");
                        let cat = CategoryChooserImpl.getCategory($elem, parseInt($nameSpan.attr("data-id"), 10));
                        if (cat)
                            selectedCategories.push(cat);
                    });
                }
            }
            return selectedCategories;
        }
        else {
            let selectedCat;
            if (mode === ChooserMode.Groups) {
                let selectedCatId = $control.data("selectedCategory");
                selectedCat = CategoryChooserImpl.getCategory($elem, selectedCatId);
            }
            else {
                let dropDown = CategoryChooserImpl.getDropDownList($elem);
                if (dropDown)
                    selectedCat = dropDown.dataItem(dropDown.select());
            }
            return (selectedCat ? [selectedCat] : []);
        }
    }
    static selectAllCategories($elem) {
        return $elem.each(function () {
            let $this = $(this);
            let synData = CategoryChooserImpl.getData($this);
            let $control = CategoryChooserImpl.getChooserControl($elem);
            if (synData.multiSelect) {
                let changed = false;
                let mode = CategoryChooserImpl.getState_ChooserMode($elem);
                if (mode === ChooserMode.Groups)
                    // not implemented
                    throw new Error(("NotImplementedException"));
                else {
                    let dropDown = CategoryChooserImpl.getDropDownList($elem);
                    dropDown.ul.find("input.multiSelectCheckBox").each((idx, curElem) => {
                        let $curElem = $(curElem);
                        let oldChecked = $curElem.prop("checked");
                        $curElem.prop("checked", true);
                        if (!oldChecked)
                            changed = true;
                    });
                }
                if (changed) {
                    $this.trigger("categoriesSelected", [CategoryChooserImpl.getSelectedCategories($this)]);
                    if (mode === ChooserMode.DropDown)
                        CategoryChooserImpl.updateDropdownHeader($this);
                    else
                        CategoryChooserImpl.updateGroupControlHeader($this, $control);
                }
            }
        });
    }
    static areAllCategoriesSelected($elem) {
        let synData = CategoryChooserImpl.getData($elem);
        let mode = CategoryChooserImpl.getState_ChooserMode($elem);
        if (synData.multiSelect) {
            let $searchRoot;
            if (mode === ChooserMode.DropDown)
                $searchRoot = CategoryChooserImpl.getDropDownList($elem).ul;
            else
                $searchRoot = CategoryChooserImpl.getChooserControl($elem);
            return $searchRoot.find("input.multiSelectCheckBox:checked").length === $searchRoot.find("input.multiSelectCheckBox").length;
        }
        return false;
    }
    static areNoCategoriesSelected($elem) {
        let synData = CategoryChooserImpl.getData($elem);
        let mode = CategoryChooserImpl.getState_ChooserMode($elem);
        if (synData.multiSelect) {
            let $searchRoot;
            let $control = CategoryChooserImpl.getChooserControl($elem);
            if (mode === ChooserMode.DropDown)
                $searchRoot = CategoryChooserImpl.getDropDownList($elem).ul;
            else
                $searchRoot = $control;
            return $searchRoot.find("input.multiSelectCheckBox:checked").length === 0;
        }
        return false;
    }
    static getAllCategories($elem) {
        return CategoryChooserImpl.getAllCategoriesCore($elem, CategoriesOrder.InGroupOrder);
    }
    static getCategoryCount($elem) {
        return CategoryChooserImpl.getAllCategoriesCore($elem, CategoriesOrder.InGroupOrder).length;
    }
    static hasCategory($elem, catId) {
        let map = CategoryChooserImpl.getCategoriesMap($elem);
        return typeof map[catId] !== "undefined";
    }
    //#region Helpers
    static getChooserControl($this) {
        return $this.find("div.chooserControl");
    }
    static getDropDownList($this) {
        return CategoryChooserImpl.getChooserControl($this).data("kendoDropDownList");
    }
    static getData($this) {
        return $this.data("synCategoryChooser");
    }
    static setData($this, data) {
        $this.data("synCategoryChooser", data);
    }
    static removeData($this) {
        $this.removeData("synCategoryChooser");
    }
    static setState_ChooserMode($this, mode) {
        $this.data("synCategoryChooserMode", mode);
    }
    static getState_ChooserMode($this) {
        return $this.data("synCategoryChooserMode");
    }
    static removeState_ChooserMode($this) {
        $this.removeData("synCategoryChooserMode");
    }
    static setState_InternalChange($this, val) {
        $this.data("synCategoryChooserInternalChange", val);
    }
    static getState_InternalChange($this) {
        return $this.data("synCategoryChooserInternalChange") || false;
    }
    static removeState_InternalChange($this) {
        $this.removeData("synCategoryChooserInternalChange");
    }
    static setState_Depends($this, val) {
        $this.data("synCategoryChooserDepends", val);
    }
    static getState_Depends($this) {
        return $this.data("synCategoryChooserDepends") || false;
    }
    static removeState_Depends($this) {
        $this.removeData("synCategoryChooserDepends");
    }
    static setState_LastSelectedIndex($this, idx) {
        $this.data("synCategoryChooserLastSelectedIdx", idx);
    }
    static getState_LastSelectedIdx($this) {
        let idx = $this.data("synCategoryChooserLastSelectedIdx");
        return (typeof idx === "undefined" ? -1 : idx);
    }
    static removeState_LastSelectedIdx($this) {
        $this.removeData("synCategoryChooserLastSelectedIdx");
    }
    static setState_CategoryGroupInfo($this, info) {
        $this.data("synCategoryChooserCategoryGroupInfo", info);
    }
    static getState_CategoryGroupInfo($this) {
        return $this.data("synCategoryChooserCategoryGroupInfo");
    }
    static removeState_CategoryGroupInfo($this) {
        $this.removeData("synCategoryChooserCategoryGroupInfo");
    }
    static setState_CategoryGroupMenu($this, groupMenu) {
        $this.data("synCategoryChooserGroupMenu", groupMenu);
    }
    static getState_CategoryGroupMenu($this) {
        return $this.data("synCategoryChooserGroupMenu");
    }
    static removeState_CategoryGroupMenu($this) {
        $this.removeData("synCategoryChooserGroupMenu");
    }
    static updateDropdownHeader($this) {
        let synData = CategoryChooserImpl.getData($this);
        let dropDownList = CategoryChooserImpl.getDropDownList($this);
        if (synData.multiSelect) {
            let text = "";
            if (CategoryChooserImpl.areAllCategoriesSelected($this))
                text = "(" + Utilities_1.synUtil.Strings.getValue("alldocs") + ")";
            else if (CategoryChooserImpl.areNoCategoriesSelected($this))
                text = "(" + Utilities_1.synUtil.Strings.getValue("synnone") + ")";
            else {
                let nameArr = $.map(CategoryChooserImpl.getSelectedCategories($this), (cat) => cat.name);
                text = nameArr.join(", ");
            }
            dropDownList.span.html(text);
        }
        else {
            let itemTemplateMarkup = require("./CategoryCombo.tmpl.html");
            let itemTemplate = kendo.template(itemTemplateMarkup);
            let dataItem = dropDownList.dataItem(dropDownList.select());
            if (dataItem) {
                let extendedItem = $.extend({}, dataItem, { synUtil: Utilities_1.synUtil, multiSelect: false, showIcons: synData.showIcons });
                dropDownList.span.html(itemTemplate(extendedItem));
            }
        }
    }
    static getAutocompleteInput($this) {
        let autocompleteInputId = $this.data("catautocompleteinputid");
        let $autoComplete = $this.find("#" + autocompleteInputId);
        return $autoComplete;
    }
    static getCategoryGroupMenuControl($this) {
        return $this.data("categoryGroupMenuControl");
    }
    static updateGroupControlHeader($this, $control) {
        let synData = CategoryChooserImpl.getData($this);
        if (!synData.multiSelect) {
            let $autoComplete = CategoryChooserImpl.getAutocompleteInput($this);
            let selectedCatId = $control.data("selectedCategory");
            if (selectedCatId) {
                let catMap = CategoryChooserImpl.getCategoriesMap($this);
                let cat = catMap[selectedCatId];
                if (cat) {
                    let bFocused = $autoComplete.is(':focus');
                    $autoComplete.data("kendoAutoComplete").value(cat.name);
                    if (synData.showIcons && cat.icon && !bFocused) {
                        $autoComplete
                            .addClass("showIcon")
                            .css("background-image", "url(" + Utilities_1.synUtil.getWSUrl("Icon") + cat.icon + "/16" + ")");
                    }
                    else {
                        $autoComplete
                            .removeClass("showIcon")
                            .css("background-image", "");
                    }
                }
            }
        }
    }
    static initTreeButton($this) {
        let synData = CategoryChooserImpl.getData($this);
        let $treeButton = $this.children(".ccTreeButton");
        Utilities_1.synUtil.toggleEnabledState($treeButton, false);
        $treeButton.on("click", function () {
            let windowData = Utilities_1.synUtil.popupWindow({
                title: Utilities_1.synUtil.Strings.getValue("cgdoctype.name.1"),
                width: 600,
                height: 400,
                modal: true
            });
            require.ensure(["./CategoryTreepicker.tmpl.less"], function (require) {
                var _a;
                require("./CategoryTreepicker.tmpl.less");
                let treePickerMarkup = require("./CategoryTreePicker.tmpl.html");
                let tpData = { synUtil: Utilities_1.synUtil };
                $.each(["Left", "Tree", "Selected", "Right", "OK", "Cancel"], function (idx, name) {
                    let c = "ctp" + name;
                    tpData[c] = c + "_" + windowData.guid;
                });
                let template2 = kendo.template(treePickerMarkup);
                windowData.contentDiv.html(template2(tpData));
                windowData.contentDiv.css("height", (windowData.contentDiv.parent().height()) + "px");
                let w = windowData.contentDiv.innerWidth();
                let h = windowData.contentDiv.innerHeight();
                $("#" + tpData.ctpLeft).css("height", h + "px");
                $("#" + tpData.ctpRight).css("height", h + "px");
                let catId = (_a = CategoryChooserImpl.getSelectedCategory($this)) === null || _a === void 0 ? void 0 : _a.id;
                if (catId)
                    Utilities_1.synUtil.getTemplate(catId, synData.mode, function (instance) {
                        let disabledCheckProperty = (synData.includeAbstractCategories ? "disabled" : "isAbstract");
                        window.setTimeout(function () {
                            let treeView = $("#" + tpData.ctpLeft)
                                .css("width", (w - ($("#" + tpData.ctpRight).outerWidth(true))) + "px")
                                .kendoTreeView({
                                dataTextField: "name",
                                template: "<input class='ftCheckBox' #= item.overrideDisabled || item." + disabledCheckProperty + "?  \'disabled=\\'disabled\\'\' : \'\' # name='input_" + windowData.guid + "' data-ftid='#= item.id #' id='cb_#= item.id #' type='radio' #= item.isChecked?  \'checked=\\'checked\\'\' : \'\' #/><label class='ftCbLabel #= item.overrideDisabled || item." + disabledCheckProperty + "?  \'k-state-disabled\' : \'\' #' for='cb_#= item.id #'>#= item.name #</label>",
                                dataSource: new kendo.data.HierarchicalDataSource({
                                    transport: {
                                        read(options) {
                                            let url = Utilities_1.synUtil.getWSUrl("PropertypageSelfRefFTEntries");
                                            let fetched = false;
                                            let rqData = {
                                                controlName: "cgdoctype.name.Input",
                                                mode: synData.mode,
                                                instance: JSON.stringify(instance.toJSON()),
                                                parentId: synData.parentId,
                                                parentRelId: synData.parentRelId,
                                                usedIn: synData.usedIn,
                                            };
                                            if (options.data.id) {
                                                let item = treeView.dataSource.get(options.data.id);
                                                if (item.childrenFetched) {
                                                    options.success(item.fetchedItems);
                                                    fetched = true;
                                                }
                                                else
                                                    rqData.parentNode = options.data.id;
                                            }
                                            if (!fetched) {
                                                Utilities_1.synUtil.getAJAXData({
                                                    method: "POST",
                                                    url,
                                                    requestData: JSON.stringify(rqData),
                                                    done(data) {
                                                        var _a;
                                                        if ((_a = synData.catIds) === null || _a === void 0 ? void 0 : _a.length) {
                                                            let queue = data.slice(0);
                                                            while (queue.length !== 0) {
                                                                let cur = queue.shift();
                                                                if (cur.fetchedItems) {
                                                                    for (let child of cur.fetchedItems)
                                                                        queue.push(child);
                                                                }
                                                                if ($.inArray(parseInt(cur.id, 10), synData.catIds) < 0)
                                                                    cur.overrideDisabled = true;
                                                            }
                                                        }
                                                        options.success(data);
                                                        // remove (+) icon if no children exist
                                                        if (!data.length) {
                                                            let treeNodeDOM = $("#" + tpData.ctpLeft).find(".k-i-loading").parent();
                                                            treeNodeDOM.find(".k-i-expand").remove();
                                                            treeNodeDOM.closest('li').addClass('synNoChildren');
                                                        }
                                                        // expand all prefetched nodes
                                                        let expandRecursive = function (dataItem) {
                                                            if (dataItem.childrenFetched) {
                                                                treeView.expand(treeView.findByUid(dataItem.uid));
                                                                $.each(dataItem.items, function (idx, subItem) {
                                                                    expandRecursive(subItem);
                                                                });
                                                            }
                                                        };
                                                        if (!options.data.id)
                                                            $.each(treeView.dataSource.data(), function (idx, rootItem) {
                                                                expandRecursive(rootItem);
                                                            });
                                                    }
                                                });
                                            }
                                        }
                                    },
                                    schema: {
                                        model: {
                                            id: "id",
                                            hasChildren: "hasChildren"
                                        }
                                    }
                                }),
                                select(e) {
                                    e.preventDefault();
                                    return false;
                                }
                            }).data("kendoTreeView");
                        }, 200);
                        $("#" + tpData.ctpOK).on("click", function () {
                            let checked;
                            $.each($("#" + tpData.ctpLeft).find("input.ftCheckBox:checked"), function (idx, checkbox) {
                                checked = $(this).attr("data-ftid");
                            });
                            if (checked) {
                                CategoryChooserImpl.setSelectedCategory($this, parseInt(checked, 10));
                                let newCateg = CategoryChooserImpl.getSelectedCategory($this);
                                if (newCateg) {
                                    $this.trigger("categorySelectedManually", {
                                        id: newCateg.id,
                                        name: newCateg.name,
                                        contentMode: newCateg.contentMode,
                                        isAbstract: newCateg.isAbstract,
                                        depends: newCateg.isAbstract || false
                                    });
                                    CategoryChooserImpl.updateTooltip($this);
                                }
                            }
                            windowData.windowDiv.data("kendoWindow").close();
                        });
                        $("#" + tpData.ctpCancel).on("click", function () {
                            windowData.windowDiv.data("kendoWindow").close();
                        });
                    });
            });
        });
    }
    static initDependsCheckbox($this) {
        let $dependsCheckBox = $this.find("input.ccDependsCheckbox");
        $dependsCheckBox.on("click", () => {
            CategoryChooserImpl.setState_Depends($this, $dependsCheckBox.prop("checked"));
        });
    }
    static initChooserControl($this, $control, synData) {
        let getCatOptions = {};
        if (synData.parentId)
            getCatOptions.parentId = synData.parentId;
        if (synData.parentRelId)
            getCatOptions.parentRelId = synData.parentRelId.toString();
        getCatOptions.includeAbstract = synData.includeAbstractCategories;
        getCatOptions.ignoreCreateRight = synData.ignoreCreateRight;
        getCatOptions.usedIn = synData.usedIn;
        if (synData.catIds)
            getCatOptions.catIds = JSON.stringify(synData.catIds);
        Utilities_1.synUtil.getAJAXData({
            method: "POST",
            url: Utilities_1.synUtil.getWSUrl("GetRelevantCategories"),
            requestData: getCatOptions,
            done(groupInfo) {
                $control.removeClass("pending");
                if (synData.showTreeButton)
                    Utilities_1.synUtil.toggleEnabledState($this.children(".ccTreeButton"), true);
                CategoryChooserImpl.setState_CategoryGroupInfo($this, groupInfo);
                let flatCategories = CategoryChooserImpl.getAllCategoriesCore($this, CategoriesOrder.InGroupOrder);
                $this.trigger("categoriesReceived", [flatCategories]);
                let $menuControl;
                if (groupInfo.useGroupsControl && synData.useCategoryGroups && Utilities_1.synUtil.clientDeviceClass !== "phone")
                    // Kategorie-Gruppen-Control ist derzeit NICHT für Anzeige auf Phones ausgelegt
                    $menuControl = CategoryChooserImpl.initChooserGroupControl($this, $control, synData);
                else
                    CategoryChooserImpl.initChooserDropDown($this, $control);
                CategoryChooserImpl.initTooltip($this, $menuControl);
                $this.trigger("initSuccess");
            },
            fail(jqXHR, textStatus, errorThrown) {
                $this.trigger("initFailed", [jqXHR, textStatus, errorThrown]);
            },
            cleanUp() {
                $this.trigger("endInit");
            }
        });
    }
    static initChooserDropDown($this, $control) {
        CategoryChooserImpl.setState_ChooserMode($this, ChooserMode.DropDown);
        let synData = CategoryChooserImpl.getData($this);
        let categories = CategoryChooserImpl.getAllCategoriesCore($this, CategoriesOrder.SortedAlphabetically);
        let itemTemplateMarkup = require("./CategoryCombo.tmpl.html");
        let _preventCloseCount = 0;
        $control
            .html("")
            .addClass("catDropDown")
            .kendoDropDownList({
            noDataTemplate: kendo.htmlEncode(Utilities_1.synUtil.Strings.getValue("dynpnomatchingitemfound")),
            animation: false,
            dataTextField: "name",
            dataValueField: "id",
            dataSource: categories,
            template(dataItem) {
                let extendedItem = $.extend({}, dataItem, { synUtil: Utilities_1.synUtil, multiSelect: synData.multiSelect, showIcons: synData.showIcons });
                return kendo.template(itemTemplateMarkup)(extendedItem);
            },
            select(e) {
                if (synData.multiSelect)
                    _preventCloseCount = 2;
            },
            open: (e) => {
                CategoryChooserImpl.hideTooltip($this);
            },
            close: (e) => {
                let dropDown = CategoryChooserImpl.getDropDownList($this);
                if (dropDown)
                    dropDown.trigger("change");
                if (synData.multiSelect && _preventCloseCount > 0) {
                    e.preventDefault();
                    _preventCloseCount--;
                }
            },
            change(e) {
                let self = this;
                let lastSelectedIdx = CategoryChooserImpl.getState_LastSelectedIdx($this);
                if (lastSelectedIdx !== self.select()) {
                    let continueObject = {
                        continueCallback: (cont) => {
                            if (cont) {
                                CategoryChooserImpl.setState_InternalChange($this, false);
                                CategoryChooserImpl.setState_LastSelectedIndex($this, self.select());
                                CategoryChooserImpl.updateDropdownHeader($this);
                                if (synData.multiSelect) {
                                    let changedData = CategoryChooserImpl.getSelectedCategories($this);
                                    $this.trigger("categoriesSelected", [changedData]);
                                    $this.trigger("categoriesSelectedManually", [changedData]);
                                }
                                else if (self.value()) {
                                    let senderId = parseInt(e.sender.value(), 10);
                                    let dataItem = e.sender.dataItem();
                                    if (synData.showDependsCheckbox) {
                                        let $dependsCheckbox = $this.find(".ccDependsCheckbox");
                                        if (dataItem.isAbstract) {
                                            if (!$dependsCheckbox.prop("disabled"))
                                                $dependsCheckbox.data("lastVal", $dependsCheckbox.prop("checked"));
                                            $dependsCheckbox.prop({ "checked": true, "disabled": true });
                                        }
                                        else {
                                            $dependsCheckbox
                                                .prop({
                                                "checked": $dependsCheckbox.data("lastVal") || false,
                                                "disabled": false
                                            });
                                        }
                                    }
                                    let changedData = {
                                        id: senderId,
                                        name: e.sender.text(),
                                        contentMode: dataItem.contentMode,
                                        isAbstract: dataItem.isAbstract,
                                        depends: synData.showDependsCheckbox ? $this.find(".ccDependsCheckbox").prop("checked") : CategoryChooserImpl.getState_Depends($this) || dataItem.isAbstract
                                    };
                                    $this.trigger("categorySelected", changedData);
                                    $this.trigger("categorySelectedManually", changedData);
                                    CategoryChooserImpl.updateTooltip($this);
                                    if (synData.selectionCookieName)
                                        Cookies.set("lastCat_" + synData.selectionCookieName, senderId.toString(), { expires: 356 });
                                }
                            }
                            else {
                                CategoryChooserImpl.setState_InternalChange($this, true);
                                self.select(CategoryChooserImpl.getState_LastSelectedIdx($this));
                                CategoryChooserImpl.updateDropdownHeader($this);
                                CategoryChooserImpl.setState_InternalChange($this, false);
                            }
                        }
                    };
                    if (!synData.multiSelect && synData.raiseBeforeSelectionChanged && !CategoryChooserImpl.getState_InternalChange($this))
                        $this.trigger("beforeCategorySelected", [continueObject]);
                    else
                        continueObject.continueCallback(true);
                }
            }
        });
        let dropDown = CategoryChooserImpl.getDropDownList($this);
        if (!synData.multiSelect) {
            let initiallyTriggered = false;
            if (typeof $.address.parameter("categoryChooserTypeId") !== "undefined") {
                let initialCat = $.address.parameter("categoryChooserTypeId");
                if (typeof initialCat !== "number")
                    initialCat = parseInt(initialCat, 10);
                let grepResult = $.grep(categories, function (cat) { return cat.id === initialCat; });
                if (grepResult.length) {
                    let foundCat = grepResult[0];
                    CategoryChooserImpl.setSelectedCategory($this, initialCat, foundCat.isAbstract, true);
                    initiallyTriggered = true;
                }
            }
            else if (synData.selectionCookieName) {
                let lastCat = Cookies.get("lastCat_" + synData.selectionCookieName);
                if (lastCat) {
                    let lastCatInt = parseInt(lastCat, 10);
                    let grepResult = $.grep(categories, function (cat) { return cat.id === lastCatInt; });
                    if (grepResult.length) {
                        let foundCat = grepResult[0];
                        CategoryChooserImpl.setSelectedCategory($this, lastCatInt, foundCat.isAbstract, true);
                        initiallyTriggered = true;
                    }
                }
            }
            CategoryChooserImpl.setState_LastSelectedIndex($this, dropDown.select());
            CategoryChooserImpl.updateDropdownHeader($this);
            if (!initiallyTriggered) {
                let curCateg = dropDown.dataItem(dropDown.select());
                if (curCateg) {
                    $this.trigger("categorySelected", {
                        id: curCateg.id,
                        name: curCateg.name,
                        contentMode: curCateg.contentMode,
                        isAbstract: curCateg.isAbstract,
                        depends: curCateg.depends
                    });
                    CategoryChooserImpl.updateTooltip($this);
                }
            }
        }
        else {
            dropDown.ul.find("li").off("click").on("click", function (e) {
                if (!$(e.target).is("input.multiSelectCheckBox"))
                    $(this).children("input.multiSelectCheckBox").trigger("click");
            });
            dropDown.ul.find("input.multiSelectCheckBox").off("change").on("change", function (e) {
                CategoryChooserImpl.updateDropdownHeader($this);
                let curSelection = CategoryChooserImpl.getSelectedCategories($this);
                $this.trigger("categoriesSelected", [curSelection]);
                $this.trigger("categoriesSelectedManually", [curSelection]);
            });
            CategoryChooserImpl.updateDropdownHeader($this);
        }
    }
    static createMenuDataItem(name, id, showIcons, icon, isGroupItem, multiSelect) {
        // icon parameter may be undefined!
        let itemHtml = "<span class='" + (isGroupItem ? "groupItem" : "category") + "'>" + kendo.htmlEncode(name) + "</span>";
        if (showIcons && icon)
            itemHtml = "<img class='icon' style='margin-right: 4px;' src='" + Utilities_1.synUtil.getWSUrl("Icon") + (icon || "transparent") + "/16" + "'>" + itemHtml;
        if (!isGroupItem && multiSelect)
            itemHtml = "<input class='multiSelectCheckBox' type='checkbox' />" + itemHtml;
        return {
            text: itemHtml,
            encoded: false,
            attr: {
                "data-id": id.toString(),
                "data-isgroupitem": (isGroupItem === null || isGroupItem === void 0 ? void 0 : isGroupItem.toString()) || "false"
            }
        };
    }
    static initChooserGroupControl($this, $control, synData) {
        CategoryChooserImpl.setState_ChooserMode($this, ChooserMode.Groups);
        let categories = CategoryChooserImpl.getAllCategoriesCore($this, CategoriesOrder.SortedAlphabetically);
        let autocompleteInputId = "catautocomplete_" + Utilities_1.synUtil.getGUID(true);
        $this.data("catautocompleteinputid", autocompleteInputId);
        let $inputControl = $('<input id="' + autocompleteInputId + '" class="ccCategoryGroupAutoComplete" ></input>').appendTo($control.html(""));
        let autocomplete = $("#" + autocompleteInputId).kendoAutoComplete({
            // minLength: 1,
            open: (evt) => { CategoryChooserImpl.hideTooltip($this); },
            noDataTemplate: kendo.htmlEncode(Utilities_1.synUtil.Strings.getValue("dynpnomatchingitemfound")),
            dataTextField: "name",
            filter: "contains",
            dataSource: categories,
            template(e) {
                let wsUrl = Utilities_1.synUtil.getWSUrl('Icon');
                return '<img style="vertical-align: middle; margin-right:4px;" src="' + wsUrl + e.icon + '/16" alt=""/><span class="name" style="vertical-align:middle">' + e.name + '</span>';
            },
            select: (e) => {
                if (synData.multiSelect)
                    // not supported
                    throw new Error(("NotImplementedException"));
                else {
                    let dataItem = autocomplete.dataItem(e.item.index());
                    let continueObject = {
                        continueCallback: (cont) => {
                            if (cont) {
                                if (synData.showDependsCheckbox) {
                                    let $dependsCheckbox = $this.find(".ccDependsCheckbox");
                                    if (dataItem.isAbstract) {
                                        if (!$dependsCheckbox.prop("disabled"))
                                            $dependsCheckbox.data("lastVal", $dependsCheckbox.prop("checked"));
                                        $dependsCheckbox.prop({ "checked": true, "disabled": true });
                                    }
                                    else {
                                        $dependsCheckbox
                                            .prop({
                                            "checked": $dependsCheckbox.data("lastVal") || false,
                                            "disabled": false
                                        });
                                    }
                                }
                                let evtData = {
                                    id: dataItem.id,
                                    name: dataItem.name,
                                    contentMode: dataItem.contentMode,
                                    isAbstract: dataItem.isAbstract,
                                    depends: synData.showDependsCheckbox ? $this.find(".ccDependsCheckbox").prop("checked") : CategoryChooserImpl.getState_Depends($this) || dataItem.isAbstract
                                };
                                $control.data("selectedCategory", dataItem.id);
                                CategoryChooserImpl.updateGroupControlHeader($this, $control);
                                $this.trigger("categorySelected", evtData);
                                $this.trigger("categorySelectedManually", evtData);
                                CategoryChooserImpl.updateTooltip($this);
                                if (synData.selectionCookieName)
                                    Cookies.set("lastCat_" + synData.selectionCookieName, dataItem.id.toString(), { expires: 356 });
                            }
                        }
                    };
                    if (synData.raiseBeforeSelectionChanged && !CategoryChooserImpl.getState_InternalChange($this))
                        $this.trigger("beforeCategorySelected", [continueObject]);
                    else
                        continueObject.continueCallback(true);
                }
            }
        }).data("kendoAutoComplete");
        // handle focus (remove icon, select all)
        $inputControl.on("focus", ($event) => {
            CategoryChooserImpl.updateGroupControlHeader($this, $control);
            if (kendo.support.browser.edge) {
                // See https://developer.microsoft.com/en-us/microsoft-edge/platform/issues/8229660/
                // https://stackoverflow.com/questions/38487059/selecting-all-content-of-text-input-on-focus-doesnt-work-in-microsoft-edge
                window.setTimeout(function () { $inputControl.select(); }, 10);
            }
            else {
                $inputControl.select();
            }
        });
        // handle blur (show icon)
        $inputControl.on("blur", () => {
            CategoryChooserImpl.updateGroupControlHeader($this, $control);
        });
        let $menuControl = CategoryChooserImpl.initCategoryGroupMenuButton($this, $control, categories);
        return $menuControl;
    }
    static initCategoryGroupMenuButton($this, $control, categories) {
        let synData = CategoryChooserImpl.getData($this);
        let groupInfo = CategoryChooserImpl.getState_CategoryGroupInfo($this);
        let dataSource = {
            text: "",
            items: []
        };
        groupInfo.groups.forEach((group) => {
            let dataItem = CategoryChooserImpl.createMenuDataItem(group.name, group.id, synData.showIcons || false, group.icon, true, synData.multiSelect || false);
            dataItem.attr = { "data-categorycontainer": "true" };
            dataItem.items = group.categories.map(cat => CategoryChooserImpl.createMenuDataItem(cat.name, cat.id, synData.showIcons || false, cat.icon, false, synData.multiSelect));
            dataSource.items.push(dataItem);
        });
        let $buttonMenu = $('<button type="button" class="k-button ccCategoryGroupMenuButton" id="catgroupmenubuttonid"><span class="k-icon k-i-arrow-60-down"></span></button>').appendTo($control);
        let $menuControl = $("<ul></ul>").appendTo($control);
        $menuControl.kendoContextMenu({
            dataSource: dataSource.items,
            orientation: "vertical",
            closeOnClick: true,
            showOn: "",
            target: $control,
            alignToAnchor: true,
            open: (evt) => { CategoryChooserImpl.hideTooltip($this); },
            select: (e) => {
                let $item = $(e.item);
                if ("false" === $item.attr("data-isgroupitem")) {
                    let catId = parseInt($item.attr("data-id"), 10);
                    let cat = CategoryChooserImpl.getCategory($this, catId);
                    if (cat) {
                        let continueObject = {
                            continueCallback: (cont) => {
                                if (cont) {
                                    if (synData.showDependsCheckbox) {
                                        let $dependsCheckbox = $this.find(".ccDependsCheckbox");
                                        if (cat.isAbstract) {
                                            if (!$dependsCheckbox.prop("disabled"))
                                                $dependsCheckbox.data("lastVal", $dependsCheckbox.prop("checked"));
                                            $dependsCheckbox.prop({ "checked": true, "disabled": true });
                                        }
                                        else {
                                            $dependsCheckbox
                                                .prop({
                                                "checked": $dependsCheckbox.data("lastVal") || false,
                                                "disabled": false
                                            });
                                        }
                                    }
                                    let evtData = {
                                        id: cat.id,
                                        name: cat.name,
                                        contentMode: cat.contentMode,
                                        isAbstract: cat.isAbstract,
                                        depends: synData.showDependsCheckbox ? $this.find(".ccDependsCheckbox").prop("checked") : CategoryChooserImpl.getState_Depends($this) || cat.isAbstract
                                    };
                                    $menuControl.data("kendoContextMenu").close($menuControl);
                                    $control.data("selectedCategory", cat.id);
                                    CategoryChooserImpl.updateGroupControlHeader($this, $control);
                                    $this.trigger("categorySelected", evtData);
                                    $this.trigger("categorySelectedManually", evtData);
                                    CategoryChooserImpl.updateTooltip($this);
                                    if (synData.selectionCookieName)
                                        Cookies.set("lastCat_" + synData.selectionCookieName, cat.id.toString(), { expires: 356 });
                                }
                                else
                                    $menuControl.data("kendoContextMenu").close($menuControl);
                            }
                        };
                        if (synData.raiseBeforeSelectionChanged && !CategoryChooserImpl.getState_InternalChange($this))
                            $this.trigger("beforeCategorySelected", [continueObject]);
                        else
                            continueObject.continueCallback(true);
                    }
                }
            }
        });
        $menuControl.addClass("ccCategoryGroupMenu");
        $this.data("categoryGroupMenuControl", $menuControl);
        CategoryChooserImpl.setState_CategoryGroupMenu($this, $menuControl.data("kendoContextMenu"));
        $menuControl.find("span.category").each((idx, elem) => {
            $(elem).closest("span.k-link").addClass("categoryListItem");
        });
        $menuControl.find("span.groupItem").each((idx, elem) => {
            let $groupListItem = $(elem).closest("span.k-link");
            $groupListItem.addClass("categoryGroupListItem");
            if (synData.showIcons)
                $groupListItem.addClass("showIcons");
        });
        if (!synData.multiSelect) {
            let initiallyTriggered = false;
            if (synData.selectionCookieName) {
                let lastCat = Cookies.get("lastCat_" + synData.selectionCookieName);
                if (lastCat) {
                    let lastCatInt = parseInt(lastCat, 10);
                    let cat = CategoryChooserImpl.getCategory($this, lastCatInt);
                    if (cat) {
                        CategoryChooserImpl.setSelectedCategory($this, lastCatInt, cat.isAbstract, true);
                        initiallyTriggered = true;
                    }
                }
            }
            if (!initiallyTriggered) {
                let firstCat = CategoryChooserImpl.getAllCategoriesCore($this, CategoriesOrder.InGroupOrder)[0];
                CategoryChooserImpl.setSelectedCategory($this, firstCat.id, firstCat.isAbstract, true);
            }
        }
        else
            // not implemented!
            throw new Error(("NotImplementedException"));
        let bContextMenuIsOpen = false;
        $buttonMenu.mousedown(function () {
            if ($menuControl.is(':visible'))
                bContextMenuIsOpen = true;
            else
                bContextMenuIsOpen = false;
        });
        $buttonMenu.on("click", function () {
            let contextMenu = $menuControl.data("kendoContextMenu");
            if (bContextMenuIsOpen)
                contextMenu.close($menuControl);
            else {
                // Die minimale Breite des ContextMenüs soll dem Control angepasst werden, damit es mit der Mouse leichter zu bedienen ist
                contextMenu.wrapper.css({
                    "min-width": $control.width() + "px"
                });
                contextMenu.resize();
                contextMenu.open($control);
            }
        });
        return $menuControl;
    }
    static registerTooltipHoverWatch($this, $menuControl) {
        let $tooltipTarget = CategoryChooserImpl.getTooltipTarget($this);
        if (!$tooltipTarget.data("tooltipHoverWatch")) {
            CategoryChooserImpl.hideTooltipConditionally($this, $menuControl);
            $tooltipTarget.data("tooltipHoverWatch", window.setInterval(() => { CategoryChooserImpl.hideTooltipConditionally($this, $menuControl); }, 100));
        }
    }
    static unregisterTooltipHoverWatch($this) {
        let $tooltipTarget = CategoryChooserImpl.getTooltipTarget($this);
        let watchId = $tooltipTarget.data("tooltipHoverWatch");
        if (watchId) {
            $tooltipTarget.removeData("tooltipHoverWatch");
            window.clearInterval(watchId);
        }
    }
    static getTooltipTarget($this) {
        let mode = CategoryChooserImpl.getState_ChooserMode($this);
        if (mode === ChooserMode.DropDown)
            return $this.children(".k-dropdown:first");
        else
            return CategoryChooserImpl.getChooserControl($this);
    }
    static updateTooltip($this) {
        let tooltip = CategoryChooserImpl.getTooltipTarget($this).data("kendoTooltip");
        if (tooltip)
            tooltip.refresh();
    }
    static hideTooltip($this) {
        CategoryChooserImpl.unregisterTooltipHoverWatch($this);
        let tooltip = CategoryChooserImpl.getTooltipTarget($this).data("kendoTooltip");
        if (tooltip)
            tooltip.hide();
    }
    static showToolTipInGroupsModeAllowed($this) {
        let bReturn = true;
        let mode = CategoryChooserImpl.getState_ChooserMode($this);
        if (mode === ChooserMode.Groups) {
            let $menuControl = CategoryChooserImpl.getCategoryGroupMenuControl($this);
            if ($menuControl)
                if ($menuControl.is(':visible'))
                    bReturn = false;
            if (bReturn) {
                let $autoComplete = CategoryChooserImpl.getAutocompleteInput($this);
                if ($autoComplete) {
                    let bFocused = $autoComplete.is(':focus');
                    bReturn = !bFocused; // Wenn das AutoComplete-InputControl den Fokus hat, blenden wir mal den Tooltip aus, da er wahrscheinlich nur stört.
                }
            }
        }
        return bReturn;
    }
    static hideTooltipConditionally($this, $menuControl) {
        let mode = CategoryChooserImpl.getState_ChooserMode($this);
        let needsToHide = !CategoryChooserImpl.hoverPositionAllowsTooltip($this);
        if (!needsToHide) {
            if (mode === ChooserMode.Groups)
                needsToHide = !CategoryChooserImpl.showToolTipInGroupsModeAllowed($this);
            else {
                let dropDown = CategoryChooserImpl.getDropDownList($this);
                if (dropDown.ul.is(":visible"))
                    needsToHide = true;
            }
        }
        if (needsToHide)
            CategoryChooserImpl.hideTooltip($this);
    }
    static hoverPositionAllowsTooltip($this) {
        let $tooltipTarget = CategoryChooserImpl.getTooltipTarget($this);
        let tooltip = $tooltipTarget.data("kendoTooltip");
        let hoversPopup = tooltip.popup.element.is(":hover");
        let hoversTarget = $tooltipTarget.is(":hover");
        let mode = CategoryChooserImpl.getState_ChooserMode($this);
        if (mode === ChooserMode.Groups) {
            let condition = (hoversTarget || hoversPopup);
            return condition;
        }
        else {
            let condition = hoversTarget || hoversPopup;
            return condition;
        }
    }
    static destroyTooltip($this) {
        let tooltip = CategoryChooserImpl.getTooltipTarget($this).data("kendoTooltip");
        if (tooltip)
            tooltip.destroy();
    }
    static initTooltip($this, $menuControl) {
        let data = CategoryChooserImpl.getData($this);
        if (data.showTooltips) {
            CategoryChooserImpl.getTooltipTarget($this).kendoTooltip({
                animation: false,
                showOn: "mouseenter",
                autoHide: true,
                showAfter: 500,
                position: "bottom",
                show(evt) {
                    var _a;
                    let tooltip = evt.sender;
                    let bShowToolTip = true;
                    bShowToolTip = CategoryChooserImpl.showToolTipInGroupsModeAllowed($this);
                    if (bShowToolTip) {
                        if (data.multiSelect) {
                            tooltip.hide();
                            return;
                        }
                        if (!((_a = CategoryChooserImpl.getSelectedCategory($this)) === null || _a === void 0 ? void 0 : _a.comment)) {
                            tooltip.hide();
                            return;
                        }
                        let tooltipContent = tooltip.content;
                        tooltipContent.addClass("synTooltip");
                        CategoryChooserImpl.registerTooltipHoverWatch($this, $menuControl);
                    }
                    else {
                        tooltip.hide();
                        return;
                    }
                },
                content: (e) => $this.synCategoryChooser("getSelectedCategory").comment,
                width: 286,
            });
        }
    }
    // CategoriesOrder.SortedAlphabetically: Return all categories flattened, without duplicates, sorted by name
    // CategoriesOrder.InGroupOrder: Return all categories flattened, in the order as they appear within their groups. May contain duplicates.
    static getAllCategoriesCore($this, catOrder) {
        if (catOrder === CategoriesOrder.SortedAlphabetically) {
            let mapCategories = CategoryChooserImpl.getCategoriesMap($this);
            let flatCategories = Object.keys(mapCategories).map((catId) => mapCategories[catId]);
            flatCategories.sort((a, b) => a.name.localeCompare(b.name));
            return flatCategories;
        }
        else {
            let groupInfo = CategoryChooserImpl.getState_CategoryGroupInfo($this);
            let arr = [];
            for (let group of groupInfo.groups)
                for (let category of group.categories)
                    arr.push(category);
            return arr;
        }
    }
    static getCategoriesMap($this) {
        let mapCategories = {};
        let groupInfo = CategoryChooserImpl.getState_CategoryGroupInfo($this);
        for (let group of groupInfo.groups)
            for (let category of group.categories)
                mapCategories[category.id] = category;
        return mapCategories;
    }
    static getCategory($this, catId) {
        return CategoryChooserImpl.getCategoriesMap($this)[catId] || undefined;
    }
    static setSelectedCategory_GroupControl($elem, catId, depends, triggerEvenIfSameCategory) {
        if (typeof triggerEvenIfSameCategory === "undefined")
            triggerEvenIfSameCategory = false;
        let $control = CategoryChooserImpl.getChooserControl($elem);
        let synData = CategoryChooserImpl.getData($elem);
        let oldCateg = CategoryChooserImpl.getSelectedCategory($elem);
        if (!synData.multiSelect)
            $control.data("selectedCategory", catId);
        else
            // not implemented
            throw new Error(("NotImplementedException"));
        let newCateg = CategoryChooserImpl.getSelectedCategory($elem);
        CategoryChooserImpl.updateGroupControlHeader($elem, $control);
        if (!synData.multiSelect && synData.showDependsCheckbox) {
            let $dependsCheckbox = $elem.children(".ccDependsCheckbox");
            if (newCateg && newCateg.isAbstract) {
                if (!$dependsCheckbox.prop("disabled"))
                    $dependsCheckbox.data("lastVal", $dependsCheckbox.prop("checked"));
                $dependsCheckbox.prop({ "checked": true, "disabled": true });
            }
            else {
                $dependsCheckbox.prop({
                    "checked": typeof depends !== "undefined" ? depends : $dependsCheckbox.data("lastVal") || false,
                    "disabled": false
                });
            }
        }
        if (newCateg && (triggerEvenIfSameCategory || !oldCateg || oldCateg.id !== newCateg.id)) {
            if (newCateg) {
                $elem.trigger("categorySelected", {
                    id: newCateg.id,
                    name: newCateg.name,
                    contentMode: newCateg.contentMode,
                    isAbstract: newCateg.isAbstract,
                    depends: synData.multiSelect ? false : (depends || newCateg.isAbstract || false)
                });
                CategoryChooserImpl.updateTooltip($elem);
            }
        }
    }
    static setSelectedCategory_DropDown($elem, catId, depends, triggerEvenIfSameCategory) {
        if (typeof triggerEvenIfSameCategory === "undefined")
            triggerEvenIfSameCategory = false;
        let synData = CategoryChooserImpl.getData($elem);
        let oldCateg = CategoryChooserImpl.getSelectedCategory($elem);
        let newCateg;
        if (synData.multiSelect) {
            CategoryChooserImpl.setSelectedCategories($elem, [catId]);
            newCateg = CategoryChooserImpl.getSelectedCategory($elem);
        }
        else {
            let dropDown = CategoryChooserImpl.getDropDownList($elem);
            dropDown.value(catId.toString());
            newCateg = CategoryChooserImpl.getSelectedCategory($elem);
            CategoryChooserImpl.setState_LastSelectedIndex($elem, dropDown.select());
            if (synData.showDependsCheckbox) {
                let $dependsCheckbox = $elem.children(".ccDependsCheckbox");
                if (newCateg && newCateg.isAbstract) {
                    if (!$dependsCheckbox.prop("disabled"))
                        $dependsCheckbox.data("lastVal", $dependsCheckbox.prop("checked"));
                    $dependsCheckbox.prop({ "checked": true, "disabled": true });
                }
                else
                    $dependsCheckbox.prop({
                        "checked": typeof depends !== "undefined" ? depends : $dependsCheckbox.data("lastVal") || false,
                        "disabled": false
                    });
            }
        }
        if (newCateg && (triggerEvenIfSameCategory || !oldCateg || oldCateg.id !== newCateg.id)) {
            CategoryChooserImpl.updateTooltip($elem);
            $elem.trigger("categorySelected", {
                id: newCateg.id,
                name: newCateg.name,
                contentMode: newCateg.contentMode,
                isAbstract: newCateg.isAbstract,
                depends: depends || newCateg.isAbstract || false
            });
            CategoryChooserImpl.updateDropdownHeader($elem);
        }
    }
}
CategoryChooserImpl.DefaultOptions = {
    parentId: undefined,
    parentRelId: 0,
    multiSelect: false,
    includeAbstractCategories: false,
    ignoreCreateRight: false,
    usedIn: exports.ChooserUsedInNew,
    mode: 4,
    useCategoryGroups: true,
    showIcons: true,
    showTreeButton: true,
    showDependsCheckbox: true,
    showTooltips: true,
    raiseBeforeSelectionChanged: false,
    selectionCookieName: undefined,
    catIds: undefined
};
// Dispatcher code
(($) => {
    $.fn.synCategoryChooser = function (method) {
        if (CategoryChooserImpl[method])
            return CategoryChooserImpl[method].apply(undefined, [this].concat(Array.prototype.slice.call(arguments, 1)));
        else if (typeof method === "object" || !method)
            return CategoryChooserImpl.init(this, arguments[0]);
        else
            $.error("Method " + method + " does not exist on jQuery.synCategoryChooser");
    };
})(jQuery);
